import {collection, component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {MetaTagDefinitionReferenceData} from "../../catalogue/meta-tag/meta-tag.data";

export enum OrderActionType {
    PAGE_CUSTOMER = <any>"PAGE_CUSTOMER",
    DISPLAY_ORDER_READY = <any>"DISPLAY_ORDER_READY"
}

export class OrderActionData extends EntityData<OrderActionData> {
    @identifier id: number;
    @field orderAtTable: boolean = true;
    @field orderAhead: boolean = true;
    @field orderDelivery: boolean = false;
    @field label: string;
    @field description: string;
    @field location: string;
    @component qualifier: MetaTagDefinitionReferenceData;
    @field actionType: OrderActionType = OrderActionType.PAGE_CUSTOMER;
    @field removeOrder: boolean = false;
}

export class OrderActionDisplayData extends EntityData<OrderActionDisplayData> {
    @identifier id: number;
    @field name: string;
    @field site: string;
    @field displayedHours: number = 4;
    @collection() outletIds: number[];
    @collection() terminalIds: number[];
    @collection() webTerminalIds: number[];
    @collection(OrderActionData) actions: OrderActionData[];
}
